export const breakpoints = {
  default: '1px',
  xs: '480px',
  sm: '768px',
  md: '992px',
  desktop: '1024px',
  lg: '1200px'
};

export const deviceBreakpoints = {
  default: {
    min: '1px',
    max: '9999px',
  },
  tablets: {
    min: '1px',
    max: '1024px',
  },
  smallMobile: {
    min: '1px',
    max: '600px',
  },
  mobile: {
    min: '600px',
    max: '1024px',
  },
  desktop: {
    min: '1024px',
    max: '1440px',
  },
  largeDesktop: {
    min: '1440px',
    max: '2200px',
  }
};

export const fontFamily = {
  primary: '\'IBM Plex Sans\', sans-serif',
  old: 'IBMPlexSans',
};

export const colors = {
  theme: {
    primary: '#017e8a',
    primary_light: '#3dbfb2',
    action: '#ff9000',
    cancel: '#d6d6d6',
    danger: '#ff483b',
    grey: '#636262',
    white: '#ffffff',
  },
  elements: {
    primary: '#3dbfb2',
  }
};
